import { useNav } from "../hooks/useNav";
import { MailingAddressForm } from "./MailingAddressForm";

export const MailingAddress = () => {
  const { state } = useNav();

  if (!state) return null;

  const { account, fullPersonalDetails } = state;

  return (
    <MailingAddressForm
      account={account}
      fullPersonalDetails={fullPersonalDetails}
    />
  );
};
